import { FlowConditionAppValuationRequestNew } from './types.flow';
import { FLOW_CONDITION_TYPES } from '../constants';

export default (): Omit<FlowConditionAppValuationRequestNew, 'id'> => ({
  type: FLOW_CONDITION_TYPES.APPVALUATIONREQUEST_NEW.type,
  app: null,
});
